import { AJAX_GET, AJAX_POST } from '../helpers/ajax'
import {AJAX_DELETE} from "../helpers/ajax.js";

export default {
    async getJobCustomerDetails(id){
      return await AJAX_GET(`/my-jobs/${id}/customer`)
    }
}
